import { createContext, useContext } from "react";

// TODO: Remove these types from duet-ui and import from here
export interface LoopNavMenuItem {
  readonly id?: string | null;
  readonly text: string;
  readonly permalink?: string | null;
  current?: boolean;
  readonly items?: ReadonlyArray<LoopNavMenuItem>;
}

export type LoopNavMenuSectionType = LoopNavMenuItem;

export type LoopNavData = {
  title: string;
  sections: ReadonlyArray<LoopNavMenuSectionType>;
} | null;

export interface LoopNavComponentProps {
  forceOpenLoopNav?: boolean;
}

export interface LoopNavContextType {
  loopNavData: LoopNavData;
  drawerId: string;
  isDrawerOpen: boolean;
  openDrawer: () => void;
  closeDrawer: () => void;
  component?: React.ComponentType<LoopNavComponentProps>;
}

const LoopNavContext = createContext<LoopNavContextType | null>(null);

export const useLoopNavContext = (): LoopNavContextType => {
  const loopNavContext = useContext(LoopNavContext);

  if (!loopNavContext) {
    throw new Error("Missing Loop Nav Context");
  }

  return loopNavContext;
};

export const useLoopNavComponentContext = (
  defaultComponent: React.ComponentType<LoopNavComponentProps>,
) => {
  const componentConfigContext = useContext(LoopNavContext);

  if (!componentConfigContext) {
    return defaultComponent;
  }

  const loopNavComponent = componentConfigContext.component;

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (!loopNavComponent) {
    return defaultComponent;
  }

  return loopNavComponent;
};

export default LoopNavContext;
